import Button from '@helsenorge/designsystem-react/components/Button';

import './modals.scss';

interface EnrollOppgaveOptionProps {
  onConfirmClick: () => void;
  onCloseClick: () => void;
  modalTitle?: string;
  confirmBtnLabel?: string;
  cancelBtnLabel?: string;
}

const EnrollOppgaveOptionModal = ({
  onConfirmClick: onConfirm,
  onCloseClick: onClose,
  modalTitle,
  confirmBtnLabel,
  cancelBtnLabel,
}: EnrollOppgaveOptionProps): React.JSX.Element => {
  return (
    <div className="modals__sticky_ramme">
      <div className="modals__container">
        <div className="modals__modalTitle">{modalTitle}</div>
        <div className="modals__buttons_container">
          <Button testId="enroll-knapp-ja" onClick={onConfirm} variant="fill">
            {confirmBtnLabel}
          </Button>
          <Button testId="enroll-knapp-nei" onClick={onClose} variant="outline">
            {cancelBtnLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EnrollOppgaveOptionModal;
